'use client';

import '../globals.css';

import { FeatureFlagsProviderAppRouter } from 'feature-flag';
import { GoogleTagManager } from 'firebase-client';
import { Comfortaa, Nunito } from 'next/font/google';
import { Suspense } from 'react';
import { AppLoader, ThemeProvider } from 'ui';

import { AuthUserProvider } from '~/auth';
import QueryProvider from '~/data';
import { I18nProvider } from '~/i18n';
import { LoggerInit } from '~/logger';
import { RumInit } from '~/rum';
import { ErrorBoundary } from '~/ui';

const comfortaa = Comfortaa({ display: 'swap', subsets: ['cyrillic-ext', 'cyrillic'], variable: '--font-comfortaa' });
const nunito = Nunito({ display: 'swap', subsets: ['cyrillic-ext', 'cyrillic'], variable: '--font-nunito' });

const RootLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <html lang="bg" className={`${comfortaa.variable} ${nunito.variable}`}>
      <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_BLENDER_GTM_CONFIG!} />
      <body>
        <RumInit />
        <LoggerInit />
        <ErrorBoundary>
          <QueryProvider>
            <I18nProvider>
              <ThemeProvider>
                <Suspense fallback={<AppLoader />}>
                  <AuthUserProvider>
                    <FeatureFlagsProviderAppRouter>{children}</FeatureFlagsProviderAppRouter>
                  </AuthUserProvider>
                </Suspense>
              </ThemeProvider>
            </I18nProvider>
          </QueryProvider>
        </ErrorBoundary>
      </body>
    </html>
  );
};

export default RootLayout;
